export default "__VITE_ASSET__CGlNWrVF__"